import { isFunction } from 'lodash';
import React from 'react';
import { useContext, useEffect } from 'react';
import {
  useGetError,
  ValidateContext,
} from 'views/context/ValidateContext';

const FieldRegister = ({
  name,
  value,
  validate,
  disabled,
  children,
  validateCallback,
  depend,
  onChange = () => null,
  ...rest
}) => {
  const {
    registerField,
    unRegisterField,
    onChangeField,
    onDependChange,
    validateField,
  } = useContext(ValidateContext);
  const errorField = useGetError(name);

  const onBlur = () => {
    validateField(name);
  };

  useEffect(() => {
    onChangeField(name, value);
    // eslint-disable-next-line
  }, [value]);

  useEffect(() => {
    onDependChange(name, depend);
    if (value) {
      onBlur();
    }
    // eslint-disable-next-line
  }, [depend]);

  useEffect(() => {
    if (disabled) {
      unRegisterField(name);
    } else {
      let funcValidate = validate;

      if (Array.isArray(validate)) {
        funcValidate = (v, a, k, d) => {
          let message = '';
          validate.forEach((item) => {
            if (!message) {
              message = item(v, a, k, d);
            }
          });
          return message;
        };
      }
      registerField(name, funcValidate, validateCallback);
      if (value) {
        onChangeField(name, value);
        onDependChange(name, depend);
      }
    }
    return () => unRegisterField(name);
    // eslint-disable-next-line
  }, [disabled]);

  return (
    isFunction(children) &&
    children({ ...rest, onBlur, onChange, value, error: errorField, disabled })
  );
};

export default React.memo(FieldRegister, (pre, next) => {
  const { children, ...restPre } = pre;
  const { children: newChild, ...restNext } = next;
  return JSON.stringify(restPre) === JSON.stringify(restNext);
});
